import { motion } from "framer-motion";

const directions = [
  "qué percepción construir",
  "qué posicionamiento ocupar",
  "qué activos fortalecer",
  "dónde intervenir",
  "en qué orden",
];

const CoressenCapital = () => {
  return (
    <section id="coressen-capital" className="py-24 md:py-32" style={{ background: "linear-gradient(180deg, #030712 0%, #0b0e14 100%)" }}>
      <div className="container px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight text-white">
            CORESSEN{" "}
            <span className="text-primary italic">CAPITAL</span>
            <span className="align-super text-base text-primary">®</span>
          </h2>
          <p className="mt-4 text-sm md:text-base uppercase tracking-[0.25em] text-primary/90">
             DIRECCIÓN ESTRATÉGICA DE CAPITAL DE MARCA®
          </p>
          <div
            className="mx-auto mt-6 h-px w-40 origin-center"
            style={{ background: "linear-gradient(to right, hsl(214, 95%, 60%), transparent)" }}
          />
        </motion.div>

        {/* Main container */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="max-w-5xl mx-auto rounded-2xl border border-white/10 p-8 md:p-14"
          style={{ background: "rgba(22, 22, 24, 0.6)" }}
        >
          {/* Intro paragraph */}
          <p className="text-center text-lg md:text-xl text-white/80 leading-relaxed max-w-4xl mx-auto">
            Identificamos la brecha entre el valor que tu empresa tiene y el que está
            logrando hacer perceptible, y definimos qué necesita construir, elevar o
            transferir.
          </p>

          {/* Sub-headline */}
          <p className="text-center text-base md:text-lg text-primary mt-10 mb-8 font-medium">
            Te llevás una dirección clara sobre:
          </p>

          {/* Five direction boxes */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {directions.map((text, i) => (
              <motion.div
                key={text}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}
                className="rounded-xl border border-white/10 p-5 text-center flex items-center justify-center"
                style={{ background: "rgba(33, 33, 33, 0.6)" }}
              >
                <span className="text-sm md:text-base text-white/85 leading-snug font-medium">
                  {text}
                </span>
              </motion.div>
            ))}
          </div>

          {/* Closing paragraph */}
          <p className="text-center text-lg md:text-xl text-white/80 leading-relaxed max-w-4xl mx-auto mt-10">
            Para dejar de invertir en acciones aisladas y empezar a gobernar tu marca
            como un activo estratégico.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CoressenCapital;
